/** The models, fabrics and elements read together by the link screen. */
import { queryOptions } from '@tanstack/react-query';
import { z } from 'zod';
import { api } from '@/shared/api/client';
import { dmsItemSchema, type AnyDmsData, type DmsItem } from '../api';

/** GET dms-item?query=: the models, fabrics and elements together (the link screen). */
export const dmsLinkItemsQueryOptions = <Data extends AnyDmsData>(
  data: z.ZodType<Data>,
) =>
  queryOptions({
    queryKey: ['dms-items', 'link'] as const,
    queryFn: () =>
      api.get<DmsItem<Data>[]>('dms-item', {
        query: {
          query: JSON.stringify({
            type: { $in: ['model', 'fabric', 'element'] },
          }),
        },
        schema: z.array(dmsItemSchema(data)),
      }),
    retry: false,
  });
